<div class="animate-fade-in">
    <app-data-table title="Módulos del Sistema"
        description="Gestiona los módulos y permisos disponibles en la plataforma" icon="mdi:puzzle-outline"
        [pagination]="pagination()" [dataSource]="modules()" [columns]="columns" [loading]="loading()"
        (onSearch)="handleSearch($event)" (onReload)="handleReload()" (onPageChange)="handlePageChange($event)"
        (onLimitChange)="handleLimitChange($event)" [columnTemplates]="{
      'label':       labelTmpl,
      'group':       groupTmpl,
      'permissions': permsTmpl,
      'isActive':    statusTmpl,
      'actions':     actionsTmpl
    }">

        <!-- ── Metrics slot: contadores por grupo ─────────────────── -->
        <ng-template #metrics>
            <app-metrics [items]="metricsItems()" (metricClick)="handleSearch($event)"></app-metrics>
        </ng-template>

        <!-- ── Action Group: botón nuevo ──────────────────────────── -->
        <ng-template #actionGroup>
            <div class="flex items-center gap-2">
                <app-button variant="glass" size="md" [square]="true" (btnClick)="syncModules()"
                    class="p-2" title="Sincronizar Módulos Base" iconLeft="solar:refresh-bold-duotone">
                </app-button>
                <app-button variant="glass" size="md" [square]="true" [spinIconOnHover]="true" class="p-2"
                    routerLink="/app/system-modules/new" title="Nuevo Módulo" [iconLeft]="'mdi:plus'">
                </app-button>
            </div>
        </ng-template>

        <!-- ── Column: Módulo (Label + Icon) ───────────────────────── -->
        <ng-template #labelTmpl let-mod>
            <div class="flex items-center gap-3">
                <div
                    class="w-10 h-10 rounded-xl bg-primary/5 border border-primary/10 flex items-center justify-center">
                    <iconify-icon [icon]="mod.icon" class="text-primary"></iconify-icon>
                </div>
                <div class="flex flex-col">
                    <span class="text-foreground font-black tracking-tight leading-none mb-1">
                        {{ mod.label }}
                    </span>
                    <span class="text-[10px] font-bold text-foreground/60 tracking-tight">
                        {{ mod.key }}
                    </span>
                </div>
            </div>
        </ng-template>

        <!-- ── Column: Grupo ──────────────────────────────────────── -->
        <ng-template #groupTmpl let-mod>
            <div class="flex items-center gap-2">
                <span class="text-xs font-bold text-foreground/75 uppercase tracking-widest">
                    {{ mod.group }}
                </span>
            </div>
        </ng-template>

        <!-- ── Column: Permisos ───────────────────────────────────── -->
        <ng-template #permsTmpl let-mod>
            <div class="flex flex-wrap gap-1 max-w-xs">
                <span *ngFor="let perm of mod.permissions"
                    class="px-2 py-0.5 rounded-md bg-primary/10 border border-primary/20 text-[10px] font-bold text-main leading-none">
                    {{ perm.split(':')[1] || perm }}
                </span>
            </div>
        </ng-template>

        <!-- ── Column: Estado ─────────────────────────────────────── -->
        <ng-template #statusTmpl let-mod>
            <app-badge [variant]="mod.isActive ? 'success' : 'danger'">
                {{ mod.isActive ? 'Activo' : 'Inactivo' }}
            </app-badge>
        </ng-template>

        <!-- ── Column: Acciones ───────────────────────────────────── -->
        <ng-template #actionsTmpl let-mod>
            <div class="flex items-center justify-end gap-1">
                <app-button variant="glass" size="xs" [square]="true" (btnClick)="viewDetails(mod)"
                    iconLeft="solar:eye-bold-duotone" title="Ver Detalles" color="text-blue-500"
                    hover="hover:text-blue-600 hover:border-blue-500/30 hover:bg-blue-500/5" class="p-1">
                </app-button>
                <app-button variant="glass" size="xs" [square]="true" color="text-green-500"
                    [routerLink]="['/app/system-modules/edit', mod._id]" iconLeft="solar:pen-new-square-linear"
                    title="Editar" hover="hover:text-green-600 hover:border-green-500/30 hover:bg-green-500/5"
                    class="p-1">
                </app-button>
                <app-button variant="glass" size="xs" [square]="true" (btnClick)="deleteModule(mod)"
                    iconLeft="solar:trash-bin-minimalistic-linear" title="Eliminar" color="text-red-500"
                    hover="hover:text-red-600 hover:border-red-500/30 hover:bg-red-500/5" class="p-1">
                </app-button>
            </div>
        </ng-template>

    </app-data-table>

    <!-- ── Modal de Detalles ────────────────────────────────────── -->
    <app-modal [isOpen]="showDetails()" (isOpenChange)="showDetails.set($event)" [title]="selectedModule()?.label || ''"
        [icon]="selectedModule()?.icon || ''">
        <div class="space-y-6 py-2" *ngIf="selectedModule() as mod">
            <!-- Header/Key info -->
            <div class="grid grid-cols-2 gap-4">
                <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03]">
                    <span
                        class="text-[10px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Key</span>
                    <span class="text-sm font-bold text-foreground">{{ mod.key }}</span>
                </div>
                <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03]">
                    <span
                        class="text-[10px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Grupo</span>
                    <div class="flex items-center gap-2">
                        <iconify-icon [icon]="mod.icon || ''" class="text-primary"></iconify-icon>
                        <span class="text-sm font-bold text-foreground">{{ mod.group }}</span>
                    </div>
                </div>
            </div>

            <!-- Route info -->
            <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03]">
                <span class="text-[10px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Ruta del
                    Módulo</span>
                <span class="text-sm font-bold text-primary">{{ mod.route || 'N/A' }}</span>
            </div>

            <!-- Permissions info -->
            <div>
                <span class="text-[10px] font-black uppercase tracking-widest text-foreground/60 block mb-3">Permisos
                    Requeridos</span>
                <div class="flex flex-wrap gap-2">
                    <div *ngFor="let perm of mod.permissions"
                        class="px-3 py-1.5 bg-primary/5 border border-primary/20 rounded-lg flex items-center gap-2 transition-all hover:bg-primary/10">
                        <iconify-icon icon="solar:shield-keyhole-bold" class="text-primary text-sm"></iconify-icon>
                        <span class="text-xs font-bold text-foreground/70">{{ perm }}</span>
                    </div>
                    <div *ngIf="!mod.permissions.length" class="text-xs text-foreground/60 italic">No requiere permisos
                        específicos</div>
                </div>
            </div>

            <!-- Order info -->
            <div
                class="flex items-center justify-between p-3 bg-surface-muted/50 rounded-xl border border-foreground/[0.03]">
                <span class="text-[10px] font-black uppercase tracking-widest text-foreground/60">Orden en el
                    Menú</span>
                <span class="text-lg font-black text-primary">{{ mod.order || 0 }}</span>
            </div>
        </div>

        <div actions class="flex justify-end items-center gap-3 w-full">
            <app-button variant="glass" size="xs" [routerLink]="['/app/system-modules/edit', selectedModule()?._id]"
                color="text-blue-500" iconLeft="solar:pen-new-square-bold" (btnClick)="showDetails.set(false)">
                Editar Módulo
            </app-button>
            <app-button variant="primary" size="xs" (btnClick)="showDetails.set(false)"
                iconLeft="solar:close-circle-bold">
                Cerrar
            </app-button>
        </div>
    </app-modal>
</div>